import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IFileStoreItem } from '../interfaces/IFileStoreItem';
import { DocumentService } from '../services/document.service';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.css']
})
export class DocumentPreviewComponent implements OnInit, OnChanges {

  @Input() files: IFileStoreItem[];
  @Output() close = new EventEmitter<boolean>();

  public activeFileIndex = 0;
  public hasPreview = false;
  public thumbnail: string = null;

  constructor(
    private documentService: DocumentService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    console.log('preview files', changes);
    if (this.files) {
      this.initAttachment(this.files[this.activeFileIndex]);
    }
  }

  ngOnInit() {
  }
  initAttachment(file: IFileStoreItem): void {
    this.hasPreview = this.documentService.hasPreview(file);
    this.thumbnail = this.documentService.getThumbnail(file);
  }  
  closePreview(evt: MouseEvent) {
    this.close.emit(true);
  }
  onPrevFile() {
    this.activeFileIndex--;
    this.initAttachment(this.files[this.activeFileIndex]);
  }
  onNextFile() {
    this.activeFileIndex++;
    this.initAttachment(this.files[this.activeFileIndex]);
  }  
}
